(function () {
  'use strict';

  /* ================================================================
     STICKY HEADER
     ================================================================ */
  var header = document.querySelector('[data-site-header]');
  if (header) {
    var onScroll = function () {
      if (window.scrollY > 8) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ================================================================
     MOBILE MENU DRAWER
     ================================================================ */
  var menu = document.querySelector('[data-mobile-menu]');
  var openButtons = document.querySelectorAll('[data-menu-open]');

  function setMenuOpen(open) {
    if (!menu) return;
    menu.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.classList.toggle('menu-open', open);
    openButtons.forEach(function (btn) {
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    if (open) {
      var firstFocusable = menu.querySelector('a, button');
      if (firstFocusable) firstFocusable.focus();
    }
  }

  openButtons.forEach(function (btn) {
    btn.addEventListener('click', function () { setMenuOpen(true); });
  });

  /* ================================================================
     REVEAL ON SCROLL
     ================================================================ */
  function observeReveal(root) {
    var els = (root || document).querySelectorAll('.reveal:not(.is-visible)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -80px 0px', threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });
  }
  observeReveal();

  /* ================================================================
     COLLECTION SORT
     ================================================================ */
  document.querySelectorAll('[data-sort-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      if (select.form) select.form.submit();
    });
  });

  /* ================================================================
     PRODUCT QUANTITY (on product page)
     ================================================================ */
  document.addEventListener('click', function (e) {
    var dec = e.target.closest('[data-qty-decrement]');
    if (dec) {
      var input = dec.parentElement.querySelector('[data-qty-input]');
      if (input) {
        var v = parseInt(input.value, 10) || 1;
        if (v > 1) input.value = v - 1;
      }
      return;
    }
    var inc = e.target.closest('[data-qty-increment]');
    if (inc) {
      var input2 = inc.parentElement.querySelector('[data-qty-input]');
      if (input2) {
        var v2 = parseInt(input2.value, 10) || 1;
        input2.value = v2 + 1;
      }
      return;
    }
  });

  /* ================================================================
     CUSTOM ELEMENTS — registered no-op so HTML names are valid
     ================================================================ */
  if ('customElements' in window) {
    ['cart-drawer', 'main-cart'].forEach(function (name) {
      if (!customElements.get(name)) {
        customElements.define(name, class extends HTMLElement {});
      }
    });
  }

  /* ================================================================
     PRODUCT VARIANT PICKER
     ================================================================ */
  if ('customElements' in window && !customElements.get('variant-selects')) {
    class VariantSelects extends HTMLElement {
      connectedCallback() {
        var dataEl = this.querySelector('[data-product-variants-json]');
        if (!dataEl) return;
        try { this.variants = JSON.parse(dataEl.textContent); }
        catch (e) { this.variants = []; return; }
        this.form = this.closest('form');
        this.priceCurrent = document.querySelector('[data-price-current]');
        this.priceCompare = document.querySelector('[data-price-compare]');
        this.priceWrap = document.querySelector('[data-product-price]');
        this.variantInput = this.form ? this.form.querySelector('[data-variant-input]') : null;
        this.addBtn = this.form ? this.form.querySelector('[data-add-to-cart]') : null;
        this.addBtnText = this.form ? this.form.querySelector('[data-add-to-cart-text]') : null;
        this.addEventListener('change', this.onChange.bind(this));
      }
      onChange() {
        var selected = [];
        this.querySelectorAll('input[type="radio"]:checked').forEach(function (input) {
          selected.push(input.value);
        });
        var variant = this.variants.find(function (v) {
          return v.options.length === selected.length &&
            v.options.every(function (opt, i) { return opt === selected[i]; });
        });
        if (!variant) return;
        if (this.variantInput) this.variantInput.value = variant.id;
        if (this.priceCurrent) this.priceCurrent.textContent = variant.price;
        if (this.priceCompare) {
          if (variant.compare_at_price) {
            this.priceCompare.textContent = variant.compare_at_price;
            this.priceCompare.style.display = '';
          } else {
            this.priceCompare.style.display = 'none';
          }
        } else if (variant.compare_at_price && this.priceWrap) {
          var s = document.createElement('s');
          s.className = 'product-info__price-compare';
          s.dataset.priceCompare = '';
          s.textContent = variant.compare_at_price;
          this.priceWrap.appendChild(s);
        }
        /* Purchase state per variant (add | preorder | soldout, from
           snippets/purchase-state): button, pre-order note and the
           "Pre-order: Yes" property follow the selected variant. */
        var state = variant.state || (variant.available ? 'add' : 'soldout');
        if (this.addBtn) {
          this.addBtn.dataset.state = state;
          this.addBtn.disabled = state === 'soldout';
        }
        if (this.form) {
          /* Every pre-order note (message + after-shipment delivery line)
             follows the variant; the standard delivery fragments do the
             opposite, so a pre-order never shows an immediate delivery time. */
          var notes = this.form.querySelectorAll('[data-preorder-note]');
          for (var ni = 0; ni < notes.length; ni++) notes[ni].hidden = state !== 'preorder';
          var stdDelivery = this.form.querySelectorAll('[data-delivery-standard]');
          for (var di = 0; di < stdDelivery.length; di++) stdDelivery[di].hidden = state === 'preorder';
          var prop = this.form.querySelector('[data-preorder-property]');
          if (prop) prop.disabled = state !== 'preorder';
        }
        var drawer = bundleDrawerEl();
        if (drawer) {
          drawer.dataset.currentVid = variant.id;
          drawer.dataset.currentPreorder = state === 'preorder' ? 'true' : '';
        }
        relabelAddButton(this.form);
        if ('URLSearchParams' in window && window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
        this.updateAvailability(selected);
        syncStickyAtc();
      }
      updateAvailability(selected) {
        var variants = this.variants;
        this.querySelectorAll('fieldset').forEach(function (fieldset, optionIndex) {
          fieldset.querySelectorAll('input[type="radio"]').forEach(function (input) {
            var hypo = selected.slice();
            hypo[optionIndex] = input.value;
            var match = variants.find(function (v) {
              return v.options.every(function (opt, i) { return opt === hypo[i]; });
            });
            input.disabled = !match || (match.state ? match.state === 'soldout' : !match.available);
          });
        });
      }
    }
    customElements.define('variant-selects', VariantSelects);
  }

  /* ================================================================
     PRODUCT RECOMMENDATIONS (lazy fetched)
     ================================================================ */
  if ('customElements' in window && !customElements.get('product-recommendations')) {
    class ProductRecommendations extends HTMLElement {
      connectedCallback() {
        var url = this.dataset.url;
        if (!url) return;
        var self = this;
        var observer = new IntersectionObserver(function (entries, obs) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            obs.unobserve(self);
            self.loadRecommendations(url);
          });
        }, { rootMargin: '0px 0px 200px 0px' });
        observer.observe(this);
      }
      loadRecommendations(url) {
        var self = this;
        fetch(url).then(function (r) { return r.text(); }).then(function (html) {
          var dom = new DOMParser().parseFromString(html, 'text/html');
          var fresh = dom.querySelector('product-recommendations');
          if (fresh && fresh.innerHTML.trim() !== '') {
            self.innerHTML = fresh.innerHTML;
            observeReveal(self);
          } else {
            var section = self.closest('.product-recommendations');
            if (section) section.style.display = 'none';
          }
        }).catch(function () {
          var section = self.closest('.product-recommendations');
          if (section) section.style.display = 'none';
        });
      }
    }
    customElements.define('product-recommendations', ProductRecommendations);
  }

  /* ================================================================
     CART DRAWER + AJAX CART LOGIC
     ================================================================ */
  var cartDrawer = function () { return document.querySelector('[data-cart-drawer]'); };

  function openCart() {
    var drawer = cartDrawer();
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-open');
    var first = drawer.querySelector('button, a');
    if (first) first.focus();
  }

  function closeCart() {
    var drawer = cartDrawer();
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-open');
  }

  function updateCartCountFromCart(cart) {
    var existing = document.querySelector('[data-cart-count]');
    var cartIcon = document.querySelector('.site-header__icon--cart');
    if (cart.item_count > 0) {
      if (existing) {
        existing.textContent = cart.item_count;
      } else if (cartIcon) {
        var span = document.createElement('span');
        span.className = 'site-header__cart-count';
        span.dataset.cartCount = '';
        span.textContent = cart.item_count;
        cartIcon.appendChild(span);
      }
    } else if (existing) {
      existing.remove();
    }
  }

  function refreshCart() {
    var sectionsToFetch = ['cart-drawer'];
    if (document.querySelector('[data-main-cart]')) sectionsToFetch.push('main-cart');
    var url = '/?sections=' + sectionsToFetch.join(',');

    return fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data['cart-drawer']) {
          var fresh = new DOMParser().parseFromString(data['cart-drawer'], 'text/html').querySelector('cart-drawer');
          var current = cartDrawer();
          if (fresh && current) {
            current.innerHTML = fresh.innerHTML;
            observeReveal(current);
          }
        }
        if (data['main-cart']) {
          var freshCart = new DOMParser().parseFromString(data['main-cart'], 'text/html').querySelector('main-cart');
          var currentCart = document.querySelector('[data-main-cart]');
          if (freshCart && currentCart) {
            currentCart.innerHTML = freshCart.innerHTML;
            observeReveal(currentCart);
          }
        }
        initCartUpsell();
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCountFromCart(cart);
      })
      .catch(function () { /* swallow */ });
  }

  function updateLineQuantity(lineKey, quantity) {
    if (quantity < 0) quantity = 0;
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refreshCart(); })
      .catch(function (e) { console.warn('Cart change failed', e); });
  }

  /* ----- Document-level event delegation for cart actions ----- */
  document.addEventListener('click', function (e) {
    // Open cart drawer when cart link clicked
    var cartLink = e.target.closest('[data-cart-link]');
    if (cartLink && cartDrawer()) {
      e.preventDefault();
      openCart();
      return;
    }

    // Close cart / mobile menu drawers
    var closeBtn = e.target.closest('[data-drawer-close]');
    if (closeBtn) {
      closeCart();
      return;
    }
    var menuClose = e.target.closest('[data-menu-close]');
    if (menuClose) {
      setMenuOpen(false);
      return;
    }

    // Cart line quantity adjust
    var qtyBtn = e.target.closest('[data-line-quantity]');
    if (qtyBtn) {
      e.preventDefault();
      var lineKey = qtyBtn.dataset.lineQuantity;
      var newQty = parseInt(qtyBtn.dataset.quantity, 10);
      updateLineQuantity(lineKey, newQty);
      return;
    }

    // Cart line remove
    var removeBtn = e.target.closest('[data-line-remove]');
    if (removeBtn) {
      e.preventDefault();
      updateLineQuantity(removeBtn.dataset.lineRemove, 0);
      return;
    }
  });

  /* ----- Esc key closes drawers ----- */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var drawer = cartDrawer();
    if (drawer && drawer.getAttribute('aria-hidden') === 'false') closeCart();
    if (menu && menu.getAttribute('aria-hidden') === 'false') setMenuOpen(false);
  });

  /* ----- Intercept product form submit for AJAX add ----- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[action$="/cart/add"], form[action*="/cart/add?"]')) return;
    if (!cartDrawer()) return; // No drawer present — let native form submit

    e.preventDefault();
    var btn = form.querySelector('[data-add-to-cart]');
    var btnText = form.querySelector('[data-add-to-cart-text]');
    var originalLabel = btnText ? btnText.textContent : '';

    if (btn) btn.disabled = true;
    if (btnText) btnText.textContent = 'Adding…';

    var formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'Accept': 'application/json' }
    })
      .then(function (resp) {
        if (!resp.ok) return resp.json().then(function (err) { throw err; });
        return resp.json();
      })
      .then(function () { return refreshCart(); })
      .then(function () {
        openCart();
        if (btn) btn.disabled = false;
        if (btnText) btnText.textContent = originalLabel;
      })
      .catch(function (err) {
        if (btn) btn.disabled = false;
        if (btnText) btnText.textContent = originalLabel;
        // Show error message inline if available
        if (err && err.description) {
          alert(err.description);
        } else {
          // Network error — fall back to native submit
          form.submit();
        }
      });
  });

  /* ================================================================
     CART UPSELL BY QUANTITY TIER (cart drawer + cart page)
     Markup: snippets/cart-upsell.liquid. A tier message with [price]
     shows "next tier total - current tier total". Those totals use the
     product page quantity selector's own data (unit price, discount3 /
     discount4 in CAD) and the same formulas as fillTierLabels: read from
     the selector when it is on the page, otherwise fetched once from the
     first cart item's product page and cached for the session. No data =
     the message stays hidden and the reassurance line stays.
     ================================================================ */
  var tierDataRequest = null;

  function tierDataFrom(fs) {
    return {
      unit: parseInt(fs.dataset.unitCents, 10),
      ref: fs.dataset.unitMoney,
      d3: parseInt(fs.dataset.d3Cad, 10) || 0,
      d4: parseInt(fs.dataset.d4Cad, 10) || 0
    };
  }

  function getTierData(sourceUrl) {
    var onPage = document.querySelector('[data-bundle-pricing]');
    if (onPage) return Promise.resolve(tierDataFrom(onPage));
    var cur = window.Shopify && window.Shopify.currency;
    var key = 'mg-tier-data:' + (cur ? cur.active + ':' + cur.rate : '');
    try {
      var cached = sessionStorage.getItem(key);
      if (cached) return Promise.resolve(JSON.parse(cached));
    } catch (e) { /* storage unavailable */ }
    if (!sourceUrl) return Promise.resolve(null);
    if (!tierDataRequest) {
      tierDataRequest = fetch(sourceUrl, { headers: { 'Accept': 'text/html' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var fs = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-bundle-pricing]');
          if (!fs) return null;
          var data = tierDataFrom(fs);
          try { sessionStorage.setItem(key, JSON.stringify(data)); } catch (e) { /* ignore */ }
          return data;
        })
        .catch(function () { tierDataRequest = null; return null; });
    }
    return tierDataRequest;
  }

  function tierTotal(data, qty) {
    if (qty === 3) return data.unit * 3 - cadToPresentment(data.d3);
    if (qty >= 4) return data.unit * 4 - cadToPresentment(data.d4);
    return data.unit * qty;
  }

  function initCartUpsell() {
    document.querySelectorAll('[data-cart-upsell]').forEach(function (box) {
      var msg = box.querySelector('[data-upsell-template]');
      if (!msg) return;
      var qty = parseInt(box.dataset.qty, 10);
      getTierData(box.dataset.tierSource).then(function (data) {
        if (!data || !data.unit || !data.ref || !box.isConnected) return;
        var price = tierTotal(data, qty + 1) - tierTotal(data, qty);
        if (!(price > 0)) return;
        msg.textContent = msg.dataset.upsellTemplate.replace('[price]', formatMoneyLike(data.ref, price));
        msg.hidden = false;
        var root = box.closest('cart-drawer, main-cart') || document;
        root.querySelectorAll('[data-cart-reassurance]').forEach(function (line) { line.hidden = true; });
      });
    });
  }

  /* One-click Add: 1 unit of the suggested design, then the same section
     re-render as every other cart change (totals, set discount, message). */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-upsell-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(btn.dataset.upsellAdd, 10), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function () { return refreshCart(); })
      .catch(function (err) {
        btn.disabled = false;
        if (err && err.description) alert(err.description);
      });
  });

  initCartUpsell();

  /* ================================================================
     MIX-AND-MATCH BUNDLE DRAWER (product page)
     Progressive enhancement over the quantity radio selector: with JS
     off, the radios keep their native behavior (quantity=N of the
     current product submits with the form).
     ================================================================ */
  var bundleDrawerEl = function () { return document.querySelector('[data-bundle-drawer]'); };

  /* ----- Presentment-currency helpers -----
     Product prices reach the DOM already in the visitor's presentment
     currency (Shopify Markets). Discount settings are raw CAD amounts:
     convert them with window.Shopify.currency.rate (presentment units
     per 1 unit of shop currency, injected by Shopify on every
     storefront; "1.0" when presentment == shop currency). */
  function presentmentRate() {
    var r = window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate);
    return (r && isFinite(r) && r > 0) ? r : 1;
  }
  function cadToPresentment(cadCents) {
    return Math.round(cadCents * presentmentRate());
  }

  /* Format an amount by cloning the pattern of a server-rendered money
     string (e.g. "$34.00", "34,00 $") — inherits the presentment
     symbol, position and separators exactly as Shopify rendered them. */
  function formatMoneyLike(reference, cents) {
    var match = (reference || '').match(/\d{1,3}(?:[., \s]\d{3})*(?:[.,]\d{1,2})?|\d+(?:[.,]\d{1,2})?/);
    if (!match) return '$' + (cents / 100).toFixed(2);
    var token = match[0];
    var decimalSep = '.';
    var m = token.match(/([.,])(\d{1,2})$/);
    if (m && m[2].length === 2) decimalSep = m[1];
    var thousandsSep = decimalSep === '.' ? ',' : '.';
    var fixed = (cents / 100).toFixed(2);
    var parts = fixed.split('.');
    var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep);
    return reference.replace(token, intPart + decimalSep + parts[1]);
  }

  var bundleState = { qty: 0, slots: [] };

  function bundleSelectedQty(form) {
    var checked = form ? form.querySelector('.quantity-select input[name="quantity"]:checked') : null;
    return checked ? parseInt(checked.value, 10) : 1;
  }

  function bundleDiscountCents(drawer, qty) {
    if (qty === 3) return cadToPresentment(parseInt(drawer.dataset.d3Cad, 10) || 0);
    if (qty >= 4) return cadToPresentment(parseInt(drawer.dataset.d4Cad, 10) || 0);
    return 0;
  }

  /* Fill tier 3/4 labels on the quantity selector: their totals mix a
     presentment unit price with a CAD discount, so they are computed
     here (post-conversion) rather than in Liquid. No JS = plain labels
     with no amounts — never a wrong number. */
  function fillTierLabels() {
    var fs = document.querySelector('[data-bundle-pricing]');
    if (!fs) return;
    var unit = parseInt(fs.dataset.unitCents, 10);
    var ref = fs.dataset.unitMoney;
    if (!unit || !ref) return;
    [3, 4].forEach(function (qty) {
      var span = fs.querySelector('[data-tier-text="' + qty + '"]');
      if (!span) return;
      var cad = parseInt(qty === 3 ? fs.dataset.d3Cad : fs.dataset.d4Cad, 10) || 0;
      var disc = cadToPresentment(cad);
      var total = unit * qty - disc;

      /* Built as DOM nodes (not textContent/innerHTML) so "Save $X"
         and "Best value" render as solid pills — Lot 5. */
      span.textContent = '';

      var main = document.createElement('span');
      main.className = 'quantity-select__main';
      main.textContent = span.dataset.label + ' — ' + formatMoneyLike(ref, total);
      span.appendChild(main);

      /* Keep the total on the radio for the button label (tiers 1-2
         carry it from Liquid), and show the per-scarf price: the same
         displayed total divided by the quantity, nothing recomputed. */
      var input = span.closest('label') && span.closest('label').querySelector('input');
      if (input) input.dataset.totalMoney = formatMoneyLike(ref, total);
      var eachTpl = fs.dataset.eachTemplate;
      if (eachTpl && eachTpl.indexOf('[price]') !== -1) {
        var each = document.createElement('span');
        each.className = 'quantity-select__each';
        each.textContent = eachTpl.replace('[price]', formatMoneyLike(ref, Math.round(total / qty)));
        span.appendChild(each);
      }

      var saveBadge = document.createElement('span');
      saveBadge.className = 'quantity-select__badge quantity-select__badge--save';
      saveBadge.textContent = fs.dataset.saveLabel + ' ' + formatMoneyLike(ref, disc);
      span.appendChild(saveBadge);

      if (qty === 4 && fs.dataset.bestValue) {
        var bestBadge = document.createElement('span');
        bestBadge.className = 'quantity-select__badge quantity-select__badge--best';
        bestBadge.textContent = fs.dataset.bestValue;
        span.appendChild(bestBadge);
      }
    });
  }
  fillTierLabels();

  /* Shipping note: no client-side conversion any more. Canada / US lines are
     typed rates rendered by Liquid; every other market shows a figure-free
     line (a converted CAD amount was wrong, e.g. France €5.16 vs €5.95). */

  function renderBundleSlots() {
    var drawer = bundleDrawerEl();
    if (!drawer) return;
    var wrap = drawer.querySelector('[data-bundle-slots]');
    wrap.innerHTML = '';
    bundleState.slots.forEach(function (slot, i) {
      var isRemovable = slot && i > 0;
      var el = document.createElement(isRemovable ? 'button' : 'div');
      if (isRemovable) el.type = 'button';
      el.className = 'bundle-slot' + (slot ? ' bundle-slot--filled' : '') + (i === 0 ? ' bundle-slot--locked' : '');
      if (slot) {
        var img = document.createElement('img');
        img.className = 'bundle-slot__thumb';
        img.src = slot.img;
        img.alt = '';
        var name = document.createElement('span');
        name.className = 'bundle-slot__name';
        name.textContent = slot.title;
        el.appendChild(img);
        el.appendChild(name);
        if (isRemovable) {
          var remove = document.createElement('span');
          remove.className = 'bundle-slot__remove';
          remove.textContent = 'Remove';
          el.appendChild(remove);
          el.setAttribute('aria-label', 'Remove ' + slot.title);
          el.addEventListener('click', function () {
            bundleState.slots[i] = null;
            renderBundleSlots();
          });
        }
      } else {
        var plus = document.createElement('span');
        plus.className = 'bundle-slot__empty';
        plus.setAttribute('aria-hidden', 'true');
        plus.textContent = '+';
        var label = document.createElement('span');
        label.className = 'bundle-slot__name';
        label.textContent = 'Choose';
        el.appendChild(plus);
        el.appendChild(label);
      }
      wrap.appendChild(el);
    });
    updateBundleSummary();
  }

  function updateBundleSummary() {
    var drawer = bundleDrawerEl();
    if (!drawer) return;
    var filled = bundleState.slots.filter(Boolean);
    var complete = filled.length === bundleState.qty;
    var moneyRef = drawer.dataset.unitMoney;
    var sum = filled.reduce(function (acc, s) { return acc + s.price; }, 0);
    // Show the tier discount only once the set is complete — a partial
    // sum minus the full-set discount would understate the total.
    var discount = complete ? bundleDiscountCents(drawer, bundleState.qty) : 0;
    var total = Math.max(0, sum - discount);
    var text = drawer.dataset.summaryTemplate
      .replace('[count]', filled.length)
      .replace('[total]', bundleState.qty)
      .replace('[price]', formatMoneyLike(moneyRef, total));
    if (discount > 0) {
      text += drawer.dataset.summarySave.replace('[savings]', formatMoneyLike(moneyRef, discount));
    }
    drawer.querySelector('[data-bundle-summary]').textContent = text;

    var confirm = drawer.querySelector('[data-bundle-confirm]');
    confirm.textContent = drawer.dataset.confirmTemplate.replace('[count]', bundleState.qty);
    confirm.disabled = !complete || confirm.dataset.busy === 'true';
  }

  function openBundleDrawer(qty) {
    var drawer = bundleDrawerEl();
    if (!drawer) return;
    bundleState.qty = qty;
    bundleState.slots = [{
      vid: parseInt(drawer.dataset.currentVid, 10),
      price: parseInt(drawer.dataset.currentPrice, 10),
      title: drawer.dataset.currentTitle,
      img: drawer.dataset.currentImg,
      preorder: drawer.dataset.currentPreorder === 'true'
    }];
    for (var i = 1; i < qty; i++) bundleState.slots.push(null);
    renderBundleSlots();
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-open');
    var first = drawer.querySelector('button');
    if (first) first.focus();
  }

  function closeBundleDrawer() {
    var drawer = bundleDrawerEl();
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-open');
  }

  document.addEventListener('click', function (e) {
    // Open: ATC click with quantity > 1
    var atc = e.target.closest('[data-add-to-cart]');
    if (atc && bundleDrawerEl()) {
      var form = atc.closest('form');
      var qty = bundleSelectedQty(form);
      if (qty > 1) {
        e.preventDefault();
        openBundleDrawer(qty);
        return;
      }
    }

    // Close buttons / backdrop
    if (e.target.closest('[data-bundle-close]')) {
      closeBundleDrawer();
      return;
    }

    // Grid item tap → fill next empty slot
    var item = e.target.closest('[data-bundle-item]');
    if (item && !item.disabled) {
      var next = bundleState.slots.indexOf(null);
      if (next === -1) return;
      bundleState.slots[next] = {
        vid: parseInt(item.dataset.vid, 10),
        price: parseInt(item.dataset.price, 10),
        title: item.dataset.title,
        img: item.dataset.img,
        preorder: item.dataset.preorder === 'true'
      };
      renderBundleSlots();
      return;
    }

    // Confirm → single multi-item /cart/add.js call
    var confirmBtn = e.target.closest('[data-bundle-confirm]');
    if (confirmBtn && !confirmBtn.disabled) {
      var drawer = bundleDrawerEl();
      var filled = bundleState.slots.filter(Boolean);
      if (filled.length !== bundleState.qty) return;
      confirmBtn.dataset.busy = 'true';
      confirmBtn.disabled = true;

      var aggregated = {};
      var preorderVids = {};
      filled.forEach(function (s) {
        aggregated[s.vid] = (aggregated[s.vid] || 0) + 1;
        if (s.preorder) preorderVids[s.vid] = true;
      });
      var items = Object.keys(aggregated).map(function (vid) {
        var line = { id: parseInt(vid, 10), quantity: aggregated[vid] };
        if (preorderVids[vid]) line.properties = { 'Pre-order': 'Yes' };
        return line;
      });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (resp) {
          if (!resp.ok) return resp.json().then(function (err) { throw err; });
          return resp.json();
        })
        .then(function () { return refreshCart(); })
        .then(function () {
          confirmBtn.dataset.busy = 'false';
          closeBundleDrawer();
          openCart();
        })
        .catch(function (err) {
          confirmBtn.dataset.busy = 'false';
          confirmBtn.disabled = false;
          if (err && err.description) alert(err.description);
        });
      return;
    }
  });

  /* Label of the main button, from its purchase state (data-state:
     add | preorder | soldout) and, with the bundle drawer, the selected
     tier: "Choose your 4 scarves — $115.33", "Pre-order — $34.00",
     "Pre-order · Choose your 4 scarves — $115.33", "Sold Out". The total
     is the one the selector already shows (data-total-money: Liquid for
     tiers 1-2, fillTierLabels for 3-4). */
  function relabelAddButton(form) {
    var btn = form ? form.querySelector('[data-add-to-cart]') : null;
    var btnText = form ? form.querySelector('[data-add-to-cart-text]') : null;
    if (!btn || !btnText) return;
    var state = btn.dataset.state || (btn.disabled ? 'soldout' : 'add');
    var preorderLabel = btn.dataset.preorderLabel || 'Pre-order';
    var label;
    var total = '';
    if (state === 'soldout') {
      label = 'Sold Out';
    } else if (bundleDrawerEl()) {
      var input = form.querySelector('.quantity-select input[name="quantity"]:checked');
      var qty = input ? parseInt(input.value, 10) : 1;
      if (qty > 1) {
        label = (btn.dataset.chooseLabel || 'Choose your [count] scarves').replace('[count]', qty);
        if (state === 'preorder') label = preorderLabel + ' · ' + label;
      } else {
        label = state === 'preorder' ? preorderLabel : (btn.dataset.addLabel || 'Add to Cart');
      }
      total = input ? (input.dataset.totalMoney || '') : '';
    } else {
      label = state === 'preorder' ? preorderLabel : (btn.dataset.addLabel || 'Add to Cart');
    }
    btn.dataset.baseLabel = label;
    btn.dataset.totalMoney = total;
    btnText.textContent = total ? label + ' — ' + total : label;
    syncStickyAtc();
  }

  /* Re-label the ATC button as the tier changes */
  document.addEventListener('change', function (e) {
    if (!e.target.matches('.quantity-select input[name="quantity"]')) return;
    if (!bundleDrawerEl()) return;
    relabelAddButton(e.target.closest('form'));
  });

  /* Initial ATC label sync (preselected tier is 4 by default) */
  (function () {
    var drawer = bundleDrawerEl();
    if (!drawer) return;
    var input = document.querySelector('.quantity-select input[name="quantity"]:checked');
    if (input) input.dispatchEvent(new Event('change', { bubbles: true }));
  })();

  /* Esc closes the bundle drawer too */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var drawer = bundleDrawerEl();
    if (drawer && drawer.getAttribute('aria-hidden') === 'false') closeBundleDrawer();
  });

  /* ================================================================
     STICKY ADD TO CART BAR (mobile, product page)
     Progressive enhancement: appears once the real Add to Cart button
     scrolls out of view (CSS additionally hides it ≥750px and while
     a drawer is open, via body.cart-open). Tapping it clicks the real
     button — it inherits every existing behavior (AJAX add, bundle
     drawer open, disabled/sold-out state) with zero cart logic
     duplicated here.
     ================================================================ */
  function syncStickyAtc() {
    var sticky = document.querySelector('[data-sticky-atc]');
    if (!sticky) return;
    var mainBtn = document.querySelector('[data-add-to-cart]');
    if (!mainBtn) return;
    var mainText = mainBtn.querySelector('[data-add-to-cart-text]');
    var priceEl = document.querySelector('[data-price-current]');
    var stickyText = sticky.querySelector('[data-sticky-atc-text]');
    var stickyPrice = sticky.querySelector('[data-sticky-atc-price]');
    var stickyBtn = sticky.querySelector('[data-sticky-atc-btn]');
    /* The bar has its own price slot: give it the tier total and keep
       the label short, so the amount isn't shown twice. */
    if (stickyText && mainText) stickyText.textContent = mainBtn.dataset.baseLabel || mainText.textContent;
    if (stickyPrice && (mainBtn.dataset.totalMoney || priceEl)) stickyPrice.textContent = mainBtn.dataset.totalMoney || priceEl.textContent;
    if (stickyBtn) stickyBtn.disabled = mainBtn.disabled;
  }
  syncStickyAtc();

  (function () {
    var sticky = document.querySelector('[data-sticky-atc]');
    var target = document.querySelector('.product-buy');
    if (!sticky || !target || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        // boundingClientRect.bottom < 0 means the real button has
        // scrolled fully above the viewport — show the sticky twin.
        sticky.setAttribute('aria-hidden', entry.boundingClientRect.bottom < 0 ? 'false' : 'true');
      });
    }, { threshold: 0 });
    io.observe(target);
  })();

  document.addEventListener('click', function (e) {
    var stickyBtn = e.target.closest('[data-sticky-atc-btn]');
    if (!stickyBtn || stickyBtn.disabled) return;
    var mainBtn = document.querySelector('[data-add-to-cart]');
    if (mainBtn) mainBtn.click();
  });
})();
